//#region src/experts-collab-platform.ts
let Tenant = /* @__PURE__ */ function(Tenant) {
	Tenant["TAX"] = "tax";
	Tenant["ALTM"] = "altm";
	Tenant["ATTORNEY"] = "attorney";
	Tenant["FULFILLMENT"] = "fulfillment";
	Tenant["LEGAL_PLANS"] = "legal_plans";
	return Tenant;
}({});
//#endregion
export { Tenant };

//# sourceMappingURL=experts-collab-platform.mjs.map